export const FormSections1073 = [
	'overview',
	'subject',
	'neighborhood',
	'projectinformation',
	'projectanalysis',
	'unitdescription',
	'comps',
	'salesapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview'
];

export const UiSections1073 = FormSections1073;

export enum RulesBase1073 {
	OVERVIEW = 1000,
	REVISIONS = 1000,
	SUBJECT = 2000,
	NEIGHBORHOOD = 3000,
	PROJECTINFORMATION = 4000,
	PROJECTANALYSIS = 4000,
	UNITDESCRIPTION = 5000,
	COMPS = 6000,
	SALESAPPROACH = 7000,
	INCOMEAPPROACH = 7500,
	RECONCILIATION = 8000,
	PDFREVIEW = 9000,
	PHOTOREVIEW = 10000
}
